import * as React from 'react';
import { createTheme, ThemeProvider, StyledEngineProvider, } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { BrowserRouter } from 'react-router-dom';
import { NotificationProvider } from '../hooks/notificationHook';
import { ConfirmationProvider } from '../hooks/confirmationHook';
import { orange, red, blue } from '@mui/material/colors';
//
import palette from './theme/palette';
import typography from './theme/typography';
import customShadows from './theme/customShadows';
import ComponentsOverrides from './theme/overrides';
// ----------------------------------------------------------------------
export var theme = createTheme({
    typography: {
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,\n    'Helvetica Neue', 'Hiragino Kaku Gothic ProN', 'Hiragino Sans', Arial,\n    'Noto Sans', 'Liberation Sans', sans-serif, 'Apple Color Emoji',\n    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
        fontSize: 14,
        h1: {
            fontSize: 20,
        },
        h2: {
            fontSize: 19,
        },
        h3: {
            fontSize: 18,
        },
        h4: {
            fontSize: 17,
        },
        h5: {
            fontSize: 16,
        },
        h6: {
            fontSize: 15,
        },
        subtitle1: {
            fontSize: 14,
        },
        subtitle2: {
            fontSize: 13,
        },
        body1: {
            fontSize: 14,
        },
        body2: {
            fontSize: 13,
        },
        caption: {
            fontSize: 12,
        },
    },
    palette: {
        primary: {
            light: '#484848',
            main: '#212121',
            dark: '#000000',
            contrastText: '#fff',
        },
        secondary: {
            light: '#4f5b62',
            main: '#263238',
            dark: '#000a12',
            contrastText: '#fff',
        },
        error: {
            light: red[300],
            main: red[500],
            dark: red[700],
        },
        warning: {
            light: orange[300],
            main: orange[500],
            dark: orange[700],
        },
        info: {
            light: blue[300],
            main: blue[500],
            dark: blue[700],
        },
        success: {
            light: '#86E8AB',
            main: '#007B55',
            dark: '#1B806A',
        },
    },
    shape: {
        borderRadius: 8,
    },
    customPalette: palette,
    customShadows: customShadows(),
    customTypography: typography,
});
theme.components = ComponentsOverrides(theme);
function AppProvider(_a) {
    var children = _a.children;
    return (React.createElement(StyledEngineProvider, { injectFirst: true },
        React.createElement(ThemeProvider, { theme: theme },
            React.createElement(LocalizationProvider, { dateAdapter: AdapterDateFns },
                React.createElement(BrowserRouter, null,
                    React.createElement(NotificationProvider, null,
                        React.createElement(ConfirmationProvider, null, children)))))));
}
export default AppProvider;
